import { FormInstance, message, Modal } from 'antd';
import { seriesService } from 'content/service';
import { Dispatch, SetStateAction } from 'react';
import { PosterInterface } from 'type/seasonType';
import { duplicatePosterSlotMessage, findDuplicatePosterSlots } from 'utils/posterSlots';

interface PosterHandlersProps {
  form: FormInstance;
  seriesId: number;
  selectedPoster: PosterInterface | null;
  setSelectedPoster: (poster: PosterInterface | null) => void;
  setNewPosterList: (posterList: PosterInterface[]) => void;
  setUploadedPosterList: (posterList: PosterInterface[]) => void;
  removedUids: string[];
  setRemovedUids: Dispatch<SetStateAction<string[]>>;
}

interface PosterHandlers {
  handlePosterUpload: () => void;
}

const handlePosterUpload = (props: PosterHandlersProps) => async (): Promise<void> => {
  const { form, seriesId } = props;
  const loadingMessage = message.loading('Creating...', 0);
  const posterList = form.getFieldValue('posterList');
  const newPosterList: PosterInterface[] = form.getFieldValue('newPosterList') || [];
  const uploadedPosterList: PosterInterface[] = form.getFieldValue('uploadedPosterList') || [];

  const duplicates = findDuplicatePosterSlots([...newPosterList, ...uploadedPosterList]);

  if (duplicates.length > 0) {
    loadingMessage();
    Modal.error({
      title: 'Error',
      content: duplicatePosterSlotMessage(duplicates),
      okText: 'Confirm',
    });
    return;
  }

  const removePosters = posterList.filter(
    (uploadedPoster: { id: number }) =>
      !uploadedPosterList.some(
        (uploadPoster: { id: number }) => uploadPoster.id === uploadedPoster.id
      )
  );

  try {
    if (removePosters.length > 0) {
      await seriesService.removePoster(seriesId, removePosters);
    }
    if (newPosterList.length > 0) {
      await seriesService.uploadPoster(seriesId, newPosterList);
    }
    message.success('upload success');
  } catch (error) {
    console.error('Failed to upload posters:', error);
  } finally {
    loadingMessage();
  }
};

const posterHandlers = (props: PosterHandlersProps): PosterHandlers => ({
  handlePosterUpload: handlePosterUpload(props),
});

export default posterHandlers;
